import { render, staticRenderFns } from "./iconKanban.vue?vue&type=template&id=26cea66b"
import script from "./iconKanban.vue?vue&type=script&lang=js"
export * from "./iconKanban.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports